import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'
import { STATUS_TONES, type Tone } from './statusTones'

const tones: Record<Tone, string> = {
  neutral: 'border-rule bg-paper-sunk text-ink-soft',
  ok: 'border-ok/25 bg-ok-wash text-ok',
  warn: 'border-warn/25 bg-warn-wash text-warn',
  danger: 'border-danger/25 bg-danger-wash text-danger',
  info: 'border-info/25 bg-info-wash text-info',
  accent: 'border-amber/30 bg-amber-wash text-amber-dark',
  reserve: 'border-reserve/25 bg-reserve-wash text-reserve',
}

export interface BadgeProps {
  tone?: Tone
  children: ReactNode
  icon?: ReactNode
  className?: string
}

export function Badge({ tone = 'neutral', children, icon, className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 whitespace-nowrap rounded-chip border px-1.5 py-0.5 font-mono text-[10.5px] font-bold uppercase tracking-label',
        tones[tone],
        className,
      )}
    >
      {icon}
      {children}
    </span>
  )
}

export function StatusPill({
  status,
  label,
  className,
}: {
  status: string
  label?: ReactNode
  className?: string
}) {
  const tone = STATUS_TONES[status.toUpperCase()] ?? 'neutral'
  return (
    <Badge tone={tone} className={className}>
      <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-current" />
      {label ?? status.replace(/_/g, ' ')}
    </Badge>
  )
}
